import Cookies from "js-cookie";

const pageViewReadyCookieName = "_ga_page_view_ready";

export function setPageViewReadyCookie(value) {
	return Cookies.set(pageViewReadyCookieName, value);
}

export function deletePageViewReadyCookie() {
	return Cookies.remove(pageViewReadyCookieName);
}

export function setMandantIdCookie() {
	return Cookies.set("sgtm_mandantid", getMandantId());
}

export function getMandantId() {
	const mandant = document.querySelector("meta[name='mandant']");
	if (mandant && mandant.content) {
		return mandant.content;
	}
	return null;
}
